import ChecklistReportNotApplicableComponent, {
  ChecklistReportNotApplicableComponentProps,
} from './ChecklistReportNotApplicableComponent';

export default ChecklistReportNotApplicableComponent;

export type { ChecklistReportNotApplicableComponentProps };
